<template>
  <div>
    <nav aria-label="Progress" class="">
      <ol role="list" class="mt-6 space-y-4 sm:flex sm:space-y-0 sm:space-x-8">
        <li v-for="(stepItem) in steps" :key="stepItem.key"  class="sm:flex-1">
          <span
            href="#"
            @click="goToStep(stepItem)"
            :class="getLinkClass(stepItem)" 
            class="pl-4 py-2 flex flex-col sm:pl-0 sm:pt-4 sm:pb-0  sm:border-t-4 border-l-4  sm:border-l-0"
          >
            <span
              :class="getSpanClass(stepItem)" 
              class="font-semibold tracking-wide uppercase"
              >{{ stepItem.name }}</span
            >
            <span v-if="false" class="text-sm font-medium">{{
              stepItem.name
            }}</span>
          </span>
    </li>
      </ol>
    </nav>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    step: String,
  },
  data() {
    return {
      activeStep: this.step,
      steps: [
        {key: "billingAddress", name: this.$t("shop.step-invoicing-address"), number : 1},
        {key: "shippingAddress", name: this.$t("shop.step-shipping-address"), number : 2},
        {key: "shippingMethod", name: this.$t("shop.step-shippingMethod"), number : 3},
        {key: "paymentMethod", name: this.$t("shop.step-paymentMethod"), number : 4},
        {key: "orderSummary", name: this.$t("shop.step-summary"), number : 5},
      ],
    };
  },
  updated(){
    if(this.step === 'billingAddress' && typeof grecaptcha !== 'undefined'){
      grecaptcha.reset()
    }
    if(this.step === 'orderSummary'){
      window.location.reload();//load correct summary, based on shipping cost
    }
  },
  methods: {
    goToStep(stepItem){
      if(!this.isUpcomingStep(stepItem)){
        this.$emit('step-change',{step: stepItem.key})
      }
    },
    getCurrentStepNumber(){
      for(var i=0; i< this.steps.length; i++){
        if(this.steps[i].key === this.step){
          return this.steps[i].number;
        }
      }
      return 0;
    },
    isCompletedStep(stepItem){
      return this.getCurrentStepNumber() > stepItem.number;
    },
    isUpcomingStep(stepItem){
      return this.getCurrentStepNumber() < stepItem.number;
    },
    getLinkClass(stepItem){
      return{
        ' group border-green-450 hover:border-green-550 cursor-pointer': this.isCompletedStep(stepItem),
        ' border-green-450 ': stepItem.key === this.step,
        ' group border-gray-200 hover:border-gray-300 ': this.isUpcomingStep(stepItem)
      };
    },
    getSpanClass(stepItem){
      return{
        'text-xs text-green-450  group-hover:text-green-550': this.isCompletedStep(stepItem),
        'text-xs text-green-450 ': stepItem.key === this.step,
        'text-xs text-gray-500  group-hover:text-gray-700': this.isUpcomingStep(stepItem)
      };
    }
  }
};
</script>
